var render, staticRenderFns
import script from "./UiRadioButton.vue?vue&type=script&lang=js"
export * from "./UiRadioButton.vue?vue&type=script&lang=js"
import style0 from "./UiRadioButton.vue?vue&type=style&index=0&id=57b809c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b809c1",
  null
  
)

export default component.exports